import React from "react";
import styles from "./AccordionComponent.module.scss";

import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { useRouter } from "next/router";

export default function AccordionComponent({ data }) {
  const router = useRouter();
  const { locale: lang } = router;

  return (
    <div className={styles["accordion-container"]}>
      <Accordion>
        {data?.map((post, index) => (
          <AccordionItem
            key={index}
            uuid={`accordion-item-${index}`}
            style={{ marginBottom: "20px" }}
          >
            <AccordionItemHeading
              className={"accordion-heading"}
              id={`accordion-heading-${index}`}
            >
              <AccordionItemButton
                className={"accordion-button"}
                dir={lang == "ar" ? "rtl" : "ltr"}
              >
                <h2
                  dir={lang == "ar" ? "rtl" : "ltr"}
                  style={{
                    marginBottom: "0",
                  }}
                >
                  {post?.data?.title?.[lang]}
                </h2>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel
              dir={lang == "ar" ? "rtl" : "ltr"}
              style={{
                fontSize: "15px",
                color: "#565656",
                paddingBlock: "10px",
                lineHeight: "1.5",
                fontWeight: "400",
              }}
            >
              {post?.data?.description?.[lang]}
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
